import settings from './modules/settings/Settings';
import user from './modules/user/User';
import theme from './modules/theme/Theme';
import support from './modules/Support';
import task from './modules/task/project_details';
import customFields from './modules/task/customFields';
import liveTimers from './modules/task/liveTimers';
import livechat from './modules/livechat/index';
import dashboardCustomisation from './modules/ghl_customization/ghl_customisation_theme';
// import sop from './modules/sop/project_details';
import userAndRoles from './modules/user/UserRoles';
import notificationSettings from './modules/settings/NotificationSettings';
import transcriptSync from '../app/Components/Views/TranscriptSync/store/transcriptSyncStore';

export default{
    modules: {
        theme,
        settings,
        user,
        userAndRoles,
        notificationSettings,
        support,
        task,
        customFields,
        liveTimers,
        livechat,
        dashboardCustomisation,
        transcriptSync
        // sop
    }
}
